import { loginRequest } from "../authConfig";
import * as microsoftTeams from "@microsoft/teams-js";



// export async function getValidAccessToken(instance, accounts) {
//   try {
//     const response = await instance.acquireTokenSilent({
//       ...loginRequest,
//       account: accounts[0],
//     });
//     return response.accessToken;
//   } catch (e) {
//     // Do not call acquireTokenPopup automatically; let the caller handle it
//     throw e;
//   }
// }

export async function getValidAccessToken(instance, accounts) {
  const response = await instance.acquireTokenSilent({
    ...loginRequest,
    account: accounts[0],
  });

  console.log("MSAL Response:", response);
  console.log("Access Token:", response?.accessToken);

  return response.accessToken;
}
export async function fetchUserDetailsByEmail(instance, accounts, email) {
  console.log("🚀 fetchUserDetailsByEmail START");
  console.log("📨 Email:", email);

  let accessToken;
  let tagValue = "graph";

  try {
    console.log("🧭 Checking if in Teams...");
    let isInTeams = false;

    try {
      await microsoftTeams.app.initialize();
      await microsoftTeams.app.getContext();
      isInTeams = true;
    } catch (e) {
      console.log("❌ Not in Teams or Teams init failed:", e);
    }

    console.log("🧭 Is in Teams:", isInTeams);

    if (isInTeams) {
      tagValue = "teams";
      console.log("🔐 Trying to get token from Teams...");
      accessToken = await new Promise((resolve, reject) => {
        microsoftTeams.authentication.getAuthToken({
          successCallback: (token) => {
            console.log("✅ Got token from Teams");
            resolve(token);
          },
          failureCallback: (err) => {
            console.error("❌ Failed to get Teams token:", err);
            reject(err);
          },
          resources: ["https://graph.microsoft.com"],
        });
      });
    } else {
      console.log("🔐 Getting web token via MSAL...");
      accessToken = await getValidAccessToken(instance, accounts);
      console.log("✅ Got web access token");
    }

    console.log("📦 Access Token:", accessToken?.substring(0, 20) + "...");

    const url = `https://land-documents-dev-ejcuftebf0dzg0e8.centralindia-01.azurewebsites.net/api/user-details?email=${encodeURIComponent(email)}&tag=${encodeURIComponent(tagValue)}`;
    console.log("🌐 Final API URL:", url);

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    });

    console.log("📬 Fetch status:", response.status);

    const json = await response.json();
    console.log("📦 JSON Response:", json);

    return {
      firstName: json.firstName || json.first_name,
      lastName: json.lastName || json.last_name,
      email: json.email,
    };
  } catch (error) {
    console.error("❌ Error in fetchUserDetailsByEmail:", error);
    throw error;
  }
}
